/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import "./start-page.scss";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "react-query";
import moment from "moment";
import SavedConfigurations from "../../../Common/components/StartPage/SavedConfigurations/SavedConfigurations";
import StartConfig from "../../../Common/components/StartPage/StartConfig/StartConfig";
import CustomPopup from "../../../Common/components/CustomPopup/CustomPopup";
import {
  selectPartnerPreferences,
  selectReFetchConfigurations,
  setConfiguration,
  setRetrofitSavedConfigurations
} from "../../../Retrofit/store/slices/retrofit";
import {
  getSavedConfigurationById,
  getSavedConfigurations,
  logEvent,
  updateConfigurationApi
} from "../../../Common/utils/api/api";
// MSC-1737: channel and subchannel surrounding may have to be removed from general getters
import { getChannel, getSubChannel } from "../../../Common/utils/func.util";
import t from "../../../Common/utils/translation/translator";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";
import {
  selectEventsData,
  selectLocale,
  selectSavedConfigurations,
  selectSeamlessSession,
  selectTechnologiesScope,
  setConfigurationType,
  setFullScreen,
  setSavedConfigurations
} from "../../../Common/store/slices/common";
import { setCartesianConfiguration, setCartesianSavedConfigurations } from "../../../Cartesian/store/slices/cartesian";
import { setMc12Configuration, setMc12SavedConfigurations } from "../../../Mc12/store/slices/mc12";
import {
  setIntegratedDrivesConfiguration,
  setIntegratedDrivesSavedConfigurations
} from "../../../IntegratedDrives/store/slices/integrated_drives";

const StartPage = () => {
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);

  const [appLoading, setAppLoading] = useState(false);

  const savedConfigurations = useSelector(selectSavedConfigurations);

  // const [savedConfigurationsRequestStatus, setSavedConfigurationsRequestStatus] = useState(
  //   Object.keys(endpointPrefixes).reduce((acc, ep) => {
  //     acc[ep] = "LOADING";
  //     return acc;
  //   }, {})
  // );

  // Function to update request status for a specific prefix
  // const updateRequestStatus = (prefix, status) => {
  //   setSavedConfigurationsRequestStatus((prevStatus) => ({
  //     ...prevStatus,
  //     [prefix]: status
  //   }));
  // };

  const locale = useSelector(selectLocale);
  const seamlessSession = useSelector(selectSeamlessSession);
  // MSC-1737: channel and subchannel surrounding may have to be removed from general getters
  const channel = seamlessSession?.userChannels?.channel1 || getChannel();
  const subChannel = seamlessSession?.userChannels?.channel2 || getSubChannel();
  const technologiesScope = useSelector(selectTechnologiesScope);
  console.log("technologiesScope", technologiesScope);

  // technologies to display
  const availableTechnologies = Object.keys(technologiesScope.technologies).filter((tech) => {
    const displayedTechnology = technologiesScope.technologies[tech].find((country) => country.locale === locale);
    return (
      displayedTechnology &&
      (displayedTechnology.channels?.includes("*") || displayedTechnology.channels?.includes(channel)) &&
      (displayedTechnology.subChannels?.includes("*") || displayedTechnology.subChannels?.includes(subChannel))
    );
  });

  const partnerPreferences = useSelector(selectPartnerPreferences);
  const partnerTechnologies = partnerPreferences?.availableTechnologies;

  function dispatchConfiguration(configs) {
    // based on the type attribute of the config ("MC12", "CARTESIAN", "RETROFIT", "INTEGRATED_DRIVES"),
    // save retrofit configurations using setRetrofitSavedConfigurations
    // save cartesian configurations using setCartesianSavedConfigurations
    // save mc12 configurations using setMc12SavedConfigurations
    // save integrated drives configurations using setIntegratedDrivesSavedConfigurations

    const retrofitConfigurations = [];
    const cartesianConfigurations = [];
    const mc12Configurations = [];
    const integratedDrivesConfigurations = [];

    configs.forEach((config) => {
      switch (config.type) {
        case "RETROFIT":
          retrofitConfigurations.push(config);
          break;
        case "CARTESIAN":
          cartesianConfigurations.push(config);
          break;
        case "MC12":
          mc12Configurations.push(config);
          break;
        case "INTEGRATED_DRIVES":
          integratedDrivesConfigurations.push(config);
          break;
        default:
          console.log("No configuration type found");
          break;
      }
    });

    // Dispatch actions with the arrays of configurations
    dispatch(setRetrofitSavedConfigurations(retrofitConfigurations));
    dispatch(setCartesianSavedConfigurations(cartesianConfigurations));
    dispatch(setMc12SavedConfigurations(mc12Configurations));
    dispatch(setIntegratedDrivesSavedConfigurations(integratedDrivesConfigurations));
  }
  // get saved configurations from the api
  const {
    refetch: execFetchConfigurations,
    isFetching,
    isLoading
  } = useQuery(
    "Get saved configurations",
    async () => {
      try {
        // Object.keys(endpointPrefixes).forEach((prefix) => {
        //   updateRequestStatus(prefix, "LOADING");
        // });

        // console.log("Getting saved configurations");
        const savedConfs = await getSavedConfigurations();

        // Update request statuses based on savedConfs
        // Object.keys(savedConfs).forEach((prefix) => {
        //   if (savedConfs[prefix] === null) {
        //     updateRequestStatus(prefix, "ERROR");
        //   } else if (Array.isArray(savedConfs[prefix])) {
        //     updateRequestStatus(prefix, "SUCCESS");
        //   }
        // });

        const combinedConfigurations = [].concat(
          ...Object.values(savedConfs).filter((sc) => typeof sc === "object" && sc !== null)
        );
        const sortedConfigurations = combinedConfigurations.sort((a, b) => b.createdDate - a.createdDate);
        dispatch(setSavedConfigurations(sortedConfigurations || []));
        dispatchConfiguration(sortedConfigurations);
        return sortedConfigurations.filter((c) => c.status === "FINISHED");
      } catch (error) {
        // Object.keys(endpointPrefixes).forEach((prefix) => {
        //   updateRequestStatus(prefix, "ERROR");
        // });
        console.error("ERR", error);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const handleDisplayContinuePopup = (configuration) => {
    setConfigurationInProgress(configuration);
    setShowPopup(true);
  };

  const startPageTabs = [
    {
      id: 1,
      label: t("msizer.ui.home.tab-start-configuration"),
      component: (
        <StartConfig
          // available technologies is an array of technologies that are in availableTechnologies and in partnerTechnologies
          // if partnerTechnologies is not defined, availableTechnologies is equal to availableTechnologies
          availableTechnologies={
            partnerTechnologies
              ? availableTechnologies.filter((tech) => partnerTechnologies.includes(tech))
              : availableTechnologies
          }
          handleDisplayContinuePopup={handleDisplayContinuePopup}
        />
      )
    },
    {
      id: 2,
      label: `${t("msizer.ui.home.tab-load-configuration")} (${
        savedConfigurations.filter((conf) => conf.status === "FINISHED").length
      })`,
      component: (
        <SavedConfigurations
          isLoading={isFetching || isLoading}
          savedConfigurations={savedConfigurations
            .filter((conf) => conf.status === "FINISHED")
            .map((c) => ({
              ...c,
              type: c.type === undefined ? "RETROFIT" : c.type
            }))}
          // requestsStatus={savedConfigurationsRequestStatus}
        />
      )
    }
  ];

  const [activeTab, setActiveTab] = useState(startPageTabs[0].id);
  const eventsData = useSelector(selectEventsData);

  const [continueConfigurationInProgress, setContinueConfigurationInProgress] = useState(false);
  const [configurationInProgress, setConfigurationInProgress] = useState(null);

  const handleContinueConfiguration = async () => {
    setAppLoading(true);
    setContinueConfigurationInProgress(true);
    // eslint-disable-next-line no-unused-vars
    const { id, type } = configurationInProgress || {};
    logEvent(eventsData.locale, eventsData.types.continueConf, eventsData.tags.none, id);
    const { configuration: configFromApi } = (await getSavedConfigurationById({ id })) || {};

    switch (type) {
      case "RETROFIT":
        dispatch(setConfiguration(configFromApi));
        dispatch(setConfigurationType(type));
        break;
      case "CARTESIAN":
        dispatch(setCartesianConfiguration(configFromApi));
        dispatch(setConfigurationType(type));
        break;
      case "MC12":
        dispatch(setMc12Configuration(configFromApi));
        dispatch(setConfigurationType(type));
        break;
      case "INTEGRATED_DRIVES":
        dispatch(setIntegratedDrivesConfiguration(configFromApi));
        dispatch(setConfigurationType(type));
        break;
      default:
        console.log("No configuration type found");
        break;
    }

    dispatch(setFullScreen(true));
    setShowPopup(false);
    setAppLoading(false);
    setContinueConfigurationInProgress(false);
  };

  const {
    refetch: execCancelConfiguration,
    isFetching: isFetchingCancelConfiguration,
    isLoading: isLoadingCancelConfiguration
  } = useQuery(
    "CANCEL : Get saved configuration by ID then change status then update it",
    async () => {
      try {
        const { id, configurationType } = configurationInProgress;
        logEvent(eventsData.locale, eventsData.types.cancelConfInProgress, eventsData.tags.none, id);
        const fetchedConf = await getSavedConfigurationById({
          id,
          configurationType
        });
        // console.log("CANCEL : fetchedConf", fetchedConf.configuration);
        fetchedConf.configuration.configData.configStatus = "CANCELLED";
        const updatedConf = await updateConfigurationApi(id, fetchedConf.configuration.configData);
        // console.log("CANCEL : updatedConf", updatedConf);
        dispatch(setFullScreen(false));
        setShowPopup(false);
        // deleting the configuration from the saved configurations
        const updatedSavedConfigurations = savedConfigurations.filter(
          (conf) => conf.id !== id && conf.type !== configurationType
        );
        setSavedConfigurations(updatedSavedConfigurations);
        dispatchConfiguration(updatedSavedConfigurations);
        return updatedConf;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const handleCancelConfiguration = () => {
    execCancelConfiguration();
  };

  const reFetchConfigurations = useSelector(selectReFetchConfigurations);
  useEffect(() => {
    execFetchConfigurations();
  }, [reFetchConfigurations]);

  const isMobile = useCheckMobileScreen();

  useEffect(() => {
    setAppLoading(isFetching || isLoading || isFetchingCancelConfiguration || isLoadingCancelConfiguration);
  }, [isFetchingCancelConfiguration, isLoadingCancelConfiguration]);

  return (
    <div className={`start-page-main-layout ${appLoading ? "opacity-50 pointer-events-none" : ""}`}>
      <CustomPopup
        title={`${t("msizer.ui.popup.incomplete_configuration.title")}
           (${configurationInProgress?.type})`}
        text={`${t("msizer.ui.popup.incomplete_configuration.text")} ${moment(
          configurationInProgress?.createdDate
        ).format("MMM DD, YYYY")} ?`}
        opened={showPopup}
        onClose={() => setShowPopup(false)}
        cancelAction={() => handleCancelConfiguration()}
        cancelLoading={isFetchingCancelConfiguration || isLoadingCancelConfiguration}
        continueAction={() => handleContinueConfiguration()}
        continueLoading={continueConfigurationInProgress}
      />
      {/* Mobile version */}
      {isMobile && (
        <div className="my-3 space-y-2">
          {startPageTabs.map((tab) => (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <>
              <div
                id={`start-tab-${tab.id}`}
                key={tab.id}
                className={`text-lg font-semibold p-2 cursor-pointer md:rounded flex items-center justify-between  ${
                  activeTab === tab.id
                    ? "!bg-white text-primary border-[1px] border-gray-200"
                    : "bg-gray-50 text-gray-500 border-[1px] border-gray-200"
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span>{tab.label}</span>
                <MsxIcons
                  size="nano"
                  name="arrow-down"
                  className={`transform transition-all duration-100 ${activeTab === tab.id ? "rotate-180" : ""}`}
                />
              </div>
              <div className={` ${isMobile ? "py-5" : "p-5"} ${activeTab === tab.id ? "block" : "hidden"}`}>
                {startPageTabs.find((elt) => elt.id === activeTab).component}
              </div>
            </>
          ))}
        </div>
      )}
      {!isMobile && (
        <>
          <div className="text-center flex">
            {startPageTabs.map((tab) => (
              // eslint-disable-next-line jsx-a11y/no-static-element-interactions
              <div
                id={`start-tab-${tab.id}`}
                key={tab.id}
                onClick={() => {
                  setActiveTab(tab.id);
                }}
                className={`flex-1 text-lg font-semibold p-2 cursor-pointer transition-all border-solid duration-100 ${
                  activeTab === tab.id
                    ? " bg-gray-5 border-t-2 border-t-gray-400 border-x-2 border-x-gray-100 text-primary"
                    : "text-gray-500"
                }`}
              >
                {tab.label}
              </div>
            ))}
          </div>
          <div className="bg-gray-5 p-5 pb-32 hidden md:block md:visible">
            {startPageTabs.find((tab) => tab.id === activeTab).component}
          </div>
        </>
      )}
    </div>
  );
};

export default StartPage;
